import { ConfigProvider, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';

import { createQuestionnaire } from '@/apis';
import bgRoot from '@/assets/images/bg-root.png';
import companyLogo from '@/assets/images/company-logo.png';
import unionLogo from '@/assets/images/union-logo.png';
import Logo from '@/components/Logo';
import OutlinedButton from '@/components/OutlinedButton';
import { useAuth } from '@/contexts/AuthContext';
import { Path } from '@/enums';
import { useApiHandler } from '@/hooks';

import * as Style from './Root.style';

const Root = () => {
  const navigate = useNavigate();
  const { handleApiCall } = useApiHandler();

  const { token } = useAuth();

  const handleCreateQuestionnaire = async () => {
    const data = await handleApiCall(() => createQuestionnaire(), {
      successMessage: '問卷建立成功！',
      context: '建立問卷',
    });
    if (data) {
      navigate(Path.Questionnaire.replace(':questionnaireId', data.id));
    }
  };

  return (
    <Style.Container $bgImage={bgRoot}>
      <Style.TopSection vertical>
        <Style.Title>
          南迴永續旅行聯盟
          <br />
          SDGs自我評估
        </Style.Title>

        <Style.ButtonContainer gap="16px">
          {token ? (
            <>
              <OutlinedButton
                width="18rem"
                height="4rem"
                onClick={() => {
                  handleCreateQuestionnaire();
                }}
              >
                START THE QUESTIONNAIRE
              </OutlinedButton>
            </>
          ) : (
            <>
              <OutlinedButton
                height="4rem"
                width="8rem"
                fontSize="1.125rem"
                onClick={() => {
                  navigate(Path.Login);
                }}
              >
                登入
              </OutlinedButton>
              <OutlinedButton
                height="4rem"
                width="8rem"
                fontSize="1.125rem"
                onClick={() => {
                  navigate(Path.Register);
                }}
              >
                註冊
              </OutlinedButton>
            </>
          )}
        </Style.ButtonContainer>
      </Style.TopSection>

      <ConfigProvider
        theme={{
          token: {
            colorSplit: '#f2f2f2',
          },
        }}
      >
        <Divider size="large" />
      </ConfigProvider>

      <Style.BottomSection justify="space-between" align="end">
        <Style.LogoContainer vertical gap="16px">
          <Logo src={companyLogo} alt="Company Logo" height="40px" />
          <Logo src={unionLogo} alt="Union Logo" height="40px" />
        </Style.LogoContainer>

        <Style.Description>
          哈囉！感謝大家抽出寶貴的時間來填寫這份問卷。
          <br />
          <br />
          透過這份評估，不僅能更深入了解自己業務在達成全球可持續發展目標方面的貢獻，還能獲得迴洄山林專門為你量身打造的評估表，希望能幫助大家走得更遠、更好。
          <br />
          <br />
          問卷中涵蓋17個SDGs指標，每個指標都有具體的評分問題。所有的資訊將會保密，僅用於研究和改善建議，不用擔心會外流～
        </Style.Description>
      </Style.BottomSection>
    </Style.Container>
  );
};

export default Root;
